module.exports = __webpack_public_path__ + "media/images/lb/885-01112f0249386b44117c02897b3e933b.svg";